import Reserve from './Reserve'

import { reservationsExistSelector } from './selectors'

export default {
  name: 'Reserve',
  component: Reserve,
  isValidSelector: reservationsExistSelector
}
